export default "__VITE_ASSET__06ac9cb5__"